/*
 *		Copyright (c) 2011-2019 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

/*
The code bellow is based on the v0.13.4 of Angular UI Bootstrap (https://github.com/angular-ui/bootstrap/blob/0.13.4/src/dropdown/dropdown.js)
and meant to replicate the `dropdown-append-to-body` functionality of the v0.13.x+ version. Remove this shim when upgrading to any version that provides this functionality.
 */
angular.module('ui.bootstrap.dropdown')
    .directive('dropdownMenu', function () {
        return {
            restrict: 'AC',
            require: '?^dropdown',
            link: function (scope, element, attrs, dropdownCtrl) {
                if (!dropdownCtrl) {
                    return;
                }
                var tplUrl = attrs.templateUrl;
                if (tplUrl) {
                    dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
                }
                if (!dropdownCtrl.dropdownMenu) {
                    dropdownCtrl.dropdownMenu = element;
                }
            }
        };
    })
    .directive('dropdownAppendToBody', ['$document', '$position', function ($document, $position) {
        return {
            require: 'dropdown',
            link: function ($scope, $element, $attrs, dropdownCtrl) {
                var
                    body = $document.find('body');

                if (dropdownCtrl.dropdownMenu) {
                    body.append(dropdownCtrl.dropdownMenu);
                    body.addClass('dropdown');
                    $element.on('$destroy', function handleDestroyEvent() {
                        dropdownCtrl.dropdownMenu.remove();
                    });
                }

                $scope.$watch(dropdownCtrl.isOpen, function (isOpen, _wasOpen) {
                    if (dropdownCtrl.dropdownMenu) {
                        var pos = $position.positionElements(dropdownCtrl.$element, dropdownCtrl.dropdownMenu, 'bottom-left', true);
                        var css = {
                            top: pos.top + 'px',
                            display: isOpen ? 'block' : 'none',
                            'z-index': 9000
                        };

                        var rightalign = dropdownCtrl.dropdownMenu.hasClass('dropdown-menu-right');
                        if (!rightalign) {
                            css.left = pos.left + 'px';
                            css.right = 'auto';
                        } else {
                            css.left = 'auto';
                            css.right = (window.innerWidth - (pos.left + dropdownCtrl.$element.prop('offsetWidth'))) + 'px';
                        }

                        dropdownCtrl.dropdownMenu.css(css);
                    }
                });
            }
        };
    }]);
